import checkValidateBricksFields from "./check-validate-bricks-fields.js";
import checkDuplicateOrder from "./check-duplicate-order.js";

export default {
	checkValidateBricksFields,
	checkDuplicateOrder,
};
